const state = {
  // 用户信息
  USER_INFO: { Token: undefined },
  // 用户组
  USER_GROUP: { ID: -1 },
  // 用户权限
  USER_PERMISSIONS: [],
  // 记住密码
  REMEMBER_PASSWORD: false,
}

export default state
